import React, { ComponentType, FunctionComponent } from 'react';
import { ObjectOf } from '../../types';
import PurchaseOrdersDropzone from '../../components/PurchaseOrdersDropzone';

/**
 * Injects the always-visible bulk-upload dropzone above the purchase
 * orders list, outside react-admin's standard filter/action toolbar so it
 * stays visible even while filters are active.
 *
 * @param Component
 */
function withPurchaseOrdersDropzone(
  Component: ComponentType<any>
): FunctionComponent {
  const Extension: FunctionComponent<ObjectOf<any>> = (props) => (
    <div>
      <PurchaseOrdersDropzone />
      <Component {...props} />
    </div>
  );

  Extension.displayName = 'withExtension(PurchaseOrdersDropzone)';

  return Extension;
}

export default withPurchaseOrdersDropzone;
